// What this order's supplier is offering today (supplier hub PR 4, 16 Oct 2026) — a reminder on the order page, so an
// offer is seen when it can still be used. Information only: it changes no price on the order.
import {Link} from 'react-router-dom';
import {useQuery} from '@tanstack/react-query';
import {useT} from '../lib/i18n';
import {authHeaders, fetchImpl} from '../lib/api';
import {env} from '../lib/env';
import {coversWords, offerWords, type SupplierPromotion} from '../pages/Suppliers';

export function SupplierPromotionNotice({supplierId}: {supplierId: string}) {
  const {t} = useT();
  const q = useQuery({queryKey: ['supplier-promotions', supplierId], queryFn: async () => {
    const r = await fetchImpl(`${env.apiBase}/api/supplier-promotions?supplier_id=${encodeURIComponent(supplierId)}`, {headers: await authHeaders()});
    const body = await r.json();
    if (!r.ok) throw Error(body.error ?? 'Unavailable');
    return body.data as SupplierPromotion[];
  }});
  const rows = q.data ?? [];
  if (!rows.length) return null;
  return <div role="status" className="mb-4 rounded-lg border border-l-4 border-l-success bg-success/10 px-4 py-2 text-sm">
    <b>{t('sup.promo.onOrder')}</b>{' '}
    {rows.map((p) => `${p.title} (${coversWords(p, t)} · ${offerWords(p, t)})`).join(' · ')}{' '}
    <Link className="text-primary underline" to={`/suppliers/${encodeURIComponent(supplierId)}`}>{t('sup.promo.see')}</Link>
  </div>;
}
